Date.prototype.format = function(format) {
  var returnStr = "";
  var replace = Date.replaceChars;
  for (var i = 0; i < format.length; i++) {
    var curChar = format.charAt(i);
    if (i - 1 >= 0 && format.charAt(i - 1) == "\\") {
      returnStr += curChar;
    } else if (replace[curChar]) {
      returnStr += replace[curChar].call(this);
    } else if (curChar != "\\") {
      returnStr += curChar;
    }
  }
  return returnStr;
};
Date.prototype.stdTimezoneOffset = function() {
  var jan = new Date(this.getFullYear(), 0, 1);
  var jul = new Date(this.getFullYear(), 6, 1);
  return Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset());
};
Date.prototype.dst = function() {
  return this.getTimezoneOffset() < this.stdTimezoneOffset();
};
Date.prototype.getWeek = function() {
  var date = new Date(this.getTime());
  date.setHours(0, 0, 0, 0);
  // Thursday in current week decides the year.
  date.setDate(date.getDate() + 3 - ((date.getDay() + 6) % 7));
  // January 4 is always in week 1.
  var week1 = new Date(date.getFullYear(), 0, 4);
  // Adjust to Thursday in week 1 and count number of weeks from date to week1.
  return (
    1 +
    Math.round(
      ((date.getTime() - week1.getTime()) / 86400000 -
        3 +
        ((week1.getDay() + 6) % 7)) /
        7
    )
  );
};

Date.replaceChars = {
  shortMonths: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  longMonths: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ],
  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  longDays: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ],
  // Day
  d: function() {
    return (this.getDate() < 10 ? "0" : "") + this.getDate();
  },
  D: function() {
    // return DDtv.getLangDWd(this.getDay());
    return Date.replaceChars.shortDays[this.getDay()];
  },
  j: function() {
    return this.getDate();
  },
  l: function() {
    // return DDtv.getLangDWd(this.getDay(), 1);
    return Date.replaceChars.longDays[this.getDay()];
  },
  N: function() {
    return this.getDay() + 1;
  },
  S: function() {
    return this.getDate() % 10 == 1 && this.getDate() != 11
      ? "st"
      : this.getDate() % 10 == 2 && this.getDate() != 12
      ? "nd"
      : this.getDate() % 10 == 3 && this.getDate() != 13
      ? "rd"
      : "th";
  },
  w: function() {
    return this.getDay();
  },
  z: function() {
    var d = new Date(this.getFullYear(), 0, 1);
    return Math.ceil((this - d) / 86400000);
  }, // Fixed now
  // Week
  W: function() {
    return this.getWeek();
    // var d = new Date(this.getFullYear(), 0, 1);
    // return Math.ceil(((this - d) / 86400000 + d.getDay() + 1) / 7);
  }, // Fixed now
  // Month
  F: function() {
    // return DDtv.getLangDY(this.getMonth(), 1);
    return Date.replaceChars.longMonths[this.getMonth()];
  },
  m: function() {
    return (this.getMonth() < 9 ? "0" : "") + (this.getMonth() + 1);
  },
  M: function() {
    // return DDtv.getLangDY(this.getMonth());
    return Date.replaceChars.shortMonths[this.getMonth()];
  },
  n: function() {
    return this.getMonth() + 1;
  },
  t: function() {
    var d = new Date();
    return new Date(d.getFullYear(), d.getMonth(), 0).getDate();
  }, // Fixed now, gets #days of date
  // Year
  L: function() {
    var year = this.getFullYear();
    return year % 400 == 0 || (year % 100 != 0 && year % 4 == 0);
  }, // Fixed now
  o: function() {
    var d = new Date(this.valueOf());
    d.setDate(d.getDate() - ((this.getDay() + 6) % 7) + 3);
    return d.getFullYear();
  }, //Fixed now
  Y: function() {
    return this.getFullYear();
  },
  y: function() {
    return ("" + this.getFullYear()).substr(2);
  },
  // Time
  a: function() {
    return this.getHours() < 12 ? "am" : "pm";
  },
  A: function() {
    return this.getHours() < 12 ? "AM" : "PM";
  },
  B: function() {
    return Math.floor(
      ((((this.getUTCHours() + 1) % 24) +
        this.getUTCMinutes() / 60 +
        this.getUTCSeconds() / 3600) *
        1000) /
        24
    );
  }, // Fixed now
  g: function() {
    return this.getHours() % 12 || 12;
  },
  G: function() {
    return this.getHours();
  },
  h: function() {
    return (
      ((this.getHours() % 12 || 12) < 10 ? "0" : "") +
      (this.getHours() % 12 || 12)
    );
  },
  H: function() {
    return (this.getHours() < 10 ? "0" : "") + this.getHours();
  },
  i: function() {
    return (this.getMinutes() < 10 ? "0" : "") + this.getMinutes();
  },
  s: function() {
    return (this.getSeconds() < 10 ? "0" : "") + this.getSeconds();
  },
  u: function() {
    var m = this.getMilliseconds();
    return (m < 10 ? "00" : m < 100 ? "0" : "") + m;
  },
  // Timezone
  e: function() {
    return "?e?";
  },
  I: function() {
    return "?I?";
  },
  O: function() {
    return (
      (-this.getTimezoneOffset() < 0 ? "-" : "+") +
      (Math.abs(this.getTimezoneOffset() / 60) < 10 ? "0" : "") +
      Math.abs(this.getTimezoneOffset() / 60) +
      "00"
    );
  },
  P: function() {
    return (
      (-this.getTimezoneOffset() < 0 ? "-" : "+") +
      (Math.abs(this.getTimezoneOffset() / 60) < 10 ? "0" : "") +
      Math.abs(this.getTimezoneOffset() / 60) +
      ":00"
    );
  }, // Fixed now
  T: function() {
    var m = this.getMonth();
    this.setMonth(0);
    var result = this.toTimeString().replace(/^.+ \(?([^\)]+)\)?$/, "$1");
    this.setMonth(m);
    return result;
  },
  Z: function() {
    return -this.getTimezoneOffset() * 60;
  },
  // Full Date/Time
  c: function() {
    return this.format("Y-m-d\\TH:i:sP");
  }, // Fixed now
  r: function() {
    return this.toString();
  },
  U: function() {
    return this.getTime() / 1000;
  }
};

var DStd = {
  isValidDate: function(d) {
    return d instanceof Date && !isNaN(d);
  },
  mkUrlFriendly: function(value) {
    return value == undefined
      ? ""
      : value
          .toLowerCase()
          .replace(/[^a-z0-9\.\-_]+/gi, "")
          .replace(/^-|-$/g, "");
  },
  round: function(value, decimals) {
    return Number(Math.round(value + "e" + decimals) + "e-" + decimals);
  },
  lPadNum(number, digits) {
    return (
      Array(Math.max(digits - String(number).length + 1, 0)).join(0) + number
    );
  },
  array_move: function(arr, old_index, new_index) {
    if (!Array.isArray(arr)) {
      return arr;
    }
    while (old_index < 0) {
      old_index += arr.length;
    }
    while (new_index < 0) {
      new_index += arr.length;
    }
    if (new_index >= arr.length) {
      let k = new_index - arr.length;
      while (k-- + 1) {
        arr.push(undefined);
      }
    }
    arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
    return arr;
  },
  clone: function(obj) {
    return JSON.parse(JSON.stringify(obj));
  },
  cloneWto: function(o1, tplO) {
    if (!typeof tplO === "object") return JSON.parse(JSON.stringify(o1));
    var r = JSON.parse(JSON.stringify(tplO));
    return Object.assign(r, o1);
  },
  copy: function copy(o) {
    var output, v, key;
    output = Array.isArray(o) ? [] : {};
    for (key in o) {
      v = o[key];
      output[key] = typeof v === "object" ? copy(v) : v;
    }
    return output;
  },
  mergeObjs: function(target, mo1) {
    if (typeof mo1 === "undefined") {
      return target;
    } else if (typeof target === "undefined") {
      return mo1;
    }
    for (var i in mo1) {
      if (mo1[i] !== null && mo1[i].constructor === Object) {
        target[i] = this.mergeObjs(target[i], mo1[i]);
      } else {
        target[i] = mo1[i];
      }
    }
    return target;
  },
  /**
   * remove items from array
   * @param  {[Array]} arr   [target array]
   * @param  {[Array]} itms1 array of itemIndexes (indexes in target array)
   * @return {[Number]} number of items actually removed
   */
  remArrInds: function(arr, itms1) {
    let cnt = 0;
    let itms = itms1.sort(function(a, b) {
      return a - b;
    });
    for (let i = itms.length; i--; ) {
      let ind = itms[i];
      cnt += arr.splice(ind, 1).length;
    }
    return cnt;
  },
  /**
   * [generate unique id]
   * @return {[String]} [unique id string/hash]
   */
  genUUID() {
    return (
      Math.random()
        .toString(36)
        .substring(2, 15) +
      Math.random()
        .toString(36)
        .substring(2, 15)
    );
  },
  genUid(pref) {
    var d = new Date().getTime();
    d += parseInt(Math.random() * 100).toString();
    if (pref === undefined) {
      pref = "uid-";
    }
    d = pref + d;
    return d;
  },
  formatBytesPs(bb) {
    // let bf=Number.parseFloat(b);
    let b = Number.parseInt(bb);
    if (Number.isNaN(b)) return "0";
    if (b <= 1000) return b + " B/s";
    else if (b <= 1000000)
      return Number.parseFloat(b / 1024).toFixed(1) + " KB/s";
    return Number.parseFloat(b / 1024 / 1024).toFixed(3) + " MB/s";
  },
  formatBytes(bb) {
    // let bf=Number.parseFloat(b);
    let b = Number.parseInt(bb);
    if (Number.isNaN(b)) return "0";
    if (b <= 1000) return b + " B";
    else if (b <= 1000000)
      return Number.parseFloat(b / 1024).toFixed(1) + " KB";
    else if (b <= 1000000000)
      return Number.parseFloat(b / 1024 / 1024).toFixed(3) + " MB";
    return Number.parseFloat(b / 1024 / 1024 / 1024).toFixed(3) + " GB";
  },
  formatKBytes(bb) {
    let b = Number.parseInt(bb);
    if (Number.isNaN(b)) return "0";
    return this.formatBytes(b * 1024);
  },
  dumpObj(o, d) {
    if (typeof d == "undefined") {
      d = 0;
    }
    if (typeof o !== "object") return "";
    var str = " :{";
    for (var i in o) {
      str += i + ": ";
      var oo = o[i];
      if (typeof oo == "object") {
        if (oo == null) str += "null, ";
        else str += (d > 0 ? this.dumpObj(oo, d - 1) : "{..}") + ", ";
      } else if (typeof oo == "function") {
        str += "()" + ", ";
      } else if (
        typeof oo == "string" ||
        typeof oo == "number" ||
        typeof oo == "boolean"
      ) {
        str += oo + ", ";
      } else {
        str += typeof oo + ", ";
      }
    }
    str += "}";
    return str;
  },
  isDate(inp) {
    if (Object.prototype.toString.call(inp) === "[object Date]") return true;
    return false;
  },
  sec2HMS(s0) {
    var s1 = parseInt(s0, 10);
    var h = Math.floor(s1 / 3600);
    var m = Math.floor(s1 / 60) % 60;
    var s = s1 % 60;
    return [h, m, s]
      .map(v => (v < 10 ? "0" + v : v))
      .filter((v, i) => v !== "00" || i > 0)
      .join(":");
  },
  min2HM(m0) {
    var m1 = parseInt(m0, 10);
    var h = Math.floor(m1 / 60);
    var m = m1 % 60;
    let a = "";
    if (h >= 1) a += h + "h";
    a += m + "m";
    return a;
    // return [h,m]
    //     .map(v => v < 10 ? "0" + v : v)
    //     .filter((v,i) => v !== "00" || i > 0)
    //     .join(":");
  },
  genRandClr() {
    return "#" + ((Math.random() * 0xffffff) << 0).toString(16);
  },
  addClass(s, n) {
    if (typeof s !== "string") s = "";
    var y = s.split(" ");
    if (y == null) y = [];
    let a = y.indexOf(n);
    if (a < 0) y.push(n);
    return y.join(" ");
  },
  removeClass(s, n) {
    if (typeof s !== "string") s = "";
    // var y = s.match(/\S+\s*/g);
    var y = s.split(" ");
    if (y == null) y = [];
    let a = y.indexOf(n);
    if (a >= 0) y.splice(a, 1);
    return y.join(" ");
  },
  toggleClass(s, n) {
    if (typeof s !== "string") s = "";
    var y = s.split(" ");
    if (y == null) y = [];
    let a = y.indexOf(n);
    if (a < 0) y.push(n);
    else y.splice(a, 1);
    return y.join(" ");
  },
  hasClass(s, n) {
    if (typeof s !== "string") return false;
    var y = s.split(" ");
    if (y == null) y = [];
    let a = y.indexOf(n);
    return a >= 0;
  },
  getDefTl(tO, dl) {
    if (!tO) return "";
    if (typeof dl !== "String") dl = "en";
    if (tO.hasOwnProperty(dl)) return tO[dl];
    for (var p in tO) return tO[p];
    return "";
  },
  isElementInViewport(el) {
    // Special bonus for those using jQuery
    if (typeof jQuery === "function" && el instanceof jQuery) {
      el = el[0];
    }
    var rect = el.getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <=
        (window.innerHeight ||
          document.documentElement.clientHeight) /* or $(window).height() */ &&
      rect.right <=
        (window.innerWidth ||
          document.documentElement.clientWidth) /* or $(window).width() */
    );
  },
  isValidTmTx(s) {
    if (s == null) return false;
    let l = s.split(":");
    if (l.length < 2 || l.length > 3) return false;
    let hh = parseInt(l[0]);
    let mm = parseInt(l[1]);
    let ss = 0;
    if (l.length == 3) ss = parseInt(l[2]);
    if (isNaN(hh) || isNaN(mm) || isNaN(ss)) return false;
    if (hh < 0 || mm < 0 || ss < 0) return false;
    if (hh > 23 || mm > 59 || ss > 59) return false;
    return true;
  },
  getFDOM(p) {
    let d = new Date(p);
    d.setDate(1);
    d.setHours(0);
    d.setMinutes(0);
    d.setSeconds(0);
    d.setMilliseconds(0);
    return d;
  },
  csv2ObjSimple(s, tplO) {
    var r = typeof tplO === "object" && tplO != null ? DStd.clone(tplO) : {};
    try {
      var l1 = s.split(",");
      for (var i = 0; i < l1.length; i++) {
        var l2 = l1[i].split("=");
        if (l2.length >= 2) r[l2[0]] = l2[1];
        else r[l2[0]] = "";
      }
    } catch (e) {}
    return r;
  },
  getCTypeInf(i) {
    let r = { cType: i, n: "?", s: "/img/logos/" };
    switch (i) {
      case 1:
        r.n = "Samsung";
        r.s += "samsung-x40.png";
        break;
      case 0:
      case 2:
        r.n = "Amino";
        r.s += "amino-x40.png";
        break;
      case 3:
        r.n = "Philips";
        r.s += "philips-x40.jpg";
        break;
      case 4:
        r.n = "Vestel";
        r.s += "vestel-x40.png";
        break;
      case 5:
        r.n = "LG";
        r.s += "lg-x40.png";
        break;
      case 5:
        r.n = "H5tv";
        r.s += "web-browser-x40.png";
        break;
      default:
        r.s = "";
        break;
    }
    return r;
  }
};

export default DStd;
